import { createQueryKeys } from '@lukemorales/query-key-factory'

import { getLibraryCodenames, getLibraryCodenamesFilters } from '../services'
import { type GetLibraryCodenamesParams } from '../types'

export const codenamesLibraryQueries = createQueryKeys('codenamesLibrary', {
  list: (params: GetLibraryCodenamesParams) => ({
    queryKey: ['list', params],
    queryFn: async () => await getLibraryCodenames(params),
  }),
  filters: () => ({
    queryKey: ['filters'],
    queryFn: async () => await getLibraryCodenamesFilters(),
  }),
})
